import React, { useState } from 'react'
import { Form } from "react-bootstrap"
import Validator from './Validator';

function CDropDownList(props) {

    //Parametros de entrada.
    const inputParam_LabelText = props.labelText;
    const inputParam_ControlName = props.controlName;
    const inputParam_SetterControlValue = props.setterControlValue;
    const inputParam_SetterControlTextValue = props.setterControlTextValue;
    const inputParam_IsInvalirControl = props.isInValid;
    const inputParam_ElementList = props.elementList;

    //Parametros de componente.
    const [isInvalidControl, setIsInvalidControl] = useState(false);
    const [selectedValueId, setSelectedValueId] = useState("");

    //Funciones de componente.
    const isInValidFormControl = (value) => {
        return value === "" ? true : false;
    }

    const checkIfIsInvalidControl = () => {
        const _isInvalidControl = isInvalidControl !== null ? isInvalidControl : false;
        const _inputParam_IsInvalirControl = inputParam_IsInvalirControl !== null ? inputParam_IsInvalirControl : false;

        return _isInvalidControl === true | _inputParam_IsInvalirControl === true ? true : false;
    }

    //Eventos de componente.
    const onChangeValue = (e) => {
        let controlValue = e.target.value;
        let controlTextValue = ""
        
        inputParam_ElementList.forEach(element => {
            if (element.id.toString() === controlValue) {
                controlTextValue = element.name;
            }
        });

        setIsInvalidControl(isInValidFormControl(controlValue));
        setSelectedValueId(controlValue);

        inputParam_SetterControlValue(controlValue);
        inputParam_SetterControlTextValue(controlTextValue);
    };

    //Render de componente.
    return (
        <>
            <Form.Label>{ inputParam_LabelText }</Form.Label>
            <Form.Select
                className="form-control"
                onChange={onChangeValue}
                name={inputParam_ControlName}
                value={(selectedValueId ? selectedValueId : undefined) || '0'}
                isInvalid={isInvalidControl !== null ? isInvalidControl : false}
                >
                { inputParam_ElementList ?  inputParam_ElementList.map((element, index) => <option key={index} value={element.id}>{element.name}</option>) : <></>}
            </Form.Select>
            <Validator isInValid={ checkIfIsInvalidControl() } />
        </>
    );
}

export default CDropDownList;